<template>
  <div class="footer">
    <div class="footer__container">
      <div class="footer__items">
        <div v-if="feedback" class="footer__item">
          <div class="footer__feedback">
            <Link
              class="color-white"
              :text="feedback.text"
              :iconLeft="feedback.icon"
              variant="inherit"
              size="sm"
              @click="$emit('feedback')"
            ></Link>
          </div>
        </div>
        <div class="footer__item">
          <div class="footer__social">
            <a
              v-for="item in socials"
              :key="item.icon"
              class="footer__social-item"
              :href="item.link"
              target="_blank"
            >
              <Icon :name="item.icon"></Icon>
            </a>
          </div>
        </div>
        <div class="footer__item" v-if="languages.length > 1">
          <Button
            ref="langSwitch"
            variant="ghost"
            view="light"
            size="md"
            :text="currentLang.text"
            icon-left="global"
          ></Button>
          <Dropdown
            trigger="langSwitch"
            placement="top"
            hide-overlay
            auto-width
          >
            <template slot="items">
              <div
                class="base-dropdown__item"
                :class="{'d-none': currentLang.id === item.id}"
                v-for="item in languages"
                :key="item.id"
              >
                <a
                  class="base-dropdown__link"
                  @click.prevent="$emit('changeLang', item.id)"
                >
                  {{ item.text }}
                </a>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="footer__item footer__copyright">
          <span class="copyright__text">
            {{ `© ${year}, ` + copyright }}<span class="text-divider"> &nbsp;|&nbsp; </span>
          </span>
          <template v-for="(item, i) in links">
            <span :key="i">
              <Link
                class="color-white"
                :text="item.text"
                :href="item.href"
                :target="item.target ? item.target : '_blank'"
                variant="inherit"
                size="sm"
              ></Link><span v-if="i < links.length-1" class="text-divider"> &nbsp;|&nbsp; </span>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@rr-component-library/button/src/main';
import Link from '@rr-component-library/link/src/main';
import Icon from '@rr-component-library/icon/src/main';
import Dropdown from './Dropdown.vue';

export default {
  name: 'Footer',
  designVersion: '1.0.0',
  components: {
    Button,
    Link,
    Icon,
    Dropdown,
  },
  props: {
    /**
     * Текст copyright, без знака авторского права и года
     */
    copyright: {
      type: String,
    },
    /**
     * Массив ссылок на e-mail, документы и т.п.
     */
    links: {
      type: Array,
    },
    /**
     * Массив ссылок на социальные сети
     */
    socials: {
      type: Array,
    },
    /**
     * Массив доступных языков (локализаций)
     */
    languages: {
      type: Array,
    },
    /**
     * Настройки элемента "Отзыв о сайте"
     */
     feedback: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    currentLang() {
      return this.languages.find((o) => (o.current === true)) || {};
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Footer";
</style>
